export default __webpack_public_path__ + "static/media/clio-rs-gallery-2.d34a4a48.jpg";